import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./RestoreConfirmationModal.css";
import RestoreIcon from '@mui/icons-material/Restore';

const RestoreConfirmationModal = ({ isOpen, onClose, onConfirm, contractName, isRestoring }) => {
  const [reason, setReason] = useState("");
  if (!isOpen) return null;

  return (
    <div className="restore-popup-overlay">
      <div className="restore-popup-content">
        <div className="restore-popup-header">
          <h3>Restore</h3>
          <button className="restore-popup-close" onClick={onClose} disabled={isRestoring}>×</button>
        </div>
        <div className="restore-popup-body">
  <p className="restore-popup-message">
    Enter reason for restoring <b>"{contractName}"</b>:
  </p>
  <textarea
    value={reason}
    onChange={(e) => setReason(e.target.value)}
    placeholder="Enter reason..."
    rows={4}
    style={{ width: "90%", padding: "8px", borderRadius: "4px" }}
  />
</div>
        
        <div className="restore-popup-footer">
  <button 
    className="restore-popup-cancel" 
    onClick={onClose} 
    disabled={isRestoring}
  >
    Cancel
  </button>
  <button 
    className="restore-popup-restore" 
    onClick={() => onConfirm(reason)} 
    disabled={isRestoring || !reason.trim()}
  >
    {isRestoring ? (
      <>
        <CircularProgress size={18} sx={{ color: "#fff" }} />
        &nbsp;Restoring...
      </>
    ) : (
      "Restore"
    )}
  </button>
</div>
      </div>
    </div>
  );
};

export default RestoreConfirmationModal;
